module.exports = __webpack_public_path__ + "img/adopt.bcff9f75.png";